var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 34,
    viewBox: "0 0 35 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0233 8.66602C16.6979 8.66602 18.304 9.33127 19.4881 10.5154C20.6723 11.6996 21.3376 13.3056 21.3376 14.9803C21.3376 16.5443 20.7644 17.982 19.8221 19.0894L20.0844 19.3517H20.8518L25.709 24.2089L24.2518 25.666L19.3947 20.8089V20.0414L19.1324 19.7792C18.025 20.7214 16.5873 21.2946 15.0233 21.2946C13.3486 21.2946 11.7426 20.6293 10.5584 19.4452C9.37424 18.261 8.70898 16.655 8.70898 14.9803C8.70898 13.3056 9.37424 11.6996 10.5584 10.5154C11.7426 9.33127 13.3486 8.66602 15.0233 8.66602ZM15.0233 10.6089C12.5947 10.6089 10.6518 12.5517 10.6518 14.9803C10.6518 17.4089 12.5947 19.3517 15.0233 19.3517C17.4518 19.3517 19.3947 17.4089 19.3947 14.9803C19.3947 12.5517 17.4518 10.6089 15.0233 10.6089Z",
    fill: "#667080"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.de6ebc4b1430c4a67607b126b0de3fb6.svg";
export { ForwardRef as ReactComponent };